module.exports = __webpack_public_path__ + "img/20.e55181cd.jpg";